import {useMapsLibrary} from '@vis.gl/react-google-maps';
import {useEffect, useState} from 'react';

function useStreetViewService() {
  const streetViewLib = useMapsLibrary('streetView');
  const [streetViewService, setStreetViewService] = useState(null);

  useEffect(() => {
    if (!streetViewLib) return;
    setStreetViewService(new streetViewLib.StreetViewService());
  }, [streetViewLib]);

  return streetViewService;
}

export default useStreetViewService;